<template>
    <font-awesome-icon :icon="icon" :size="size"/>
</template>

<script>
    export default {
        name: "Icon",
        props: {
            icon: {
                type: String,
                required: true,
            },

            // optional
            size: {
                type: String,
                default: 'sm',
                validator: (value) => ['xs', 'sm', 'lg', '2x', '3x'].indexOf(value) !== -1,
            },
        },
    }
</script>
